var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_311_437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.7127 5.72436L26.5007 0.0195312L9.28865 5.72436C7.99184 6.15426 6.86346 6.98185 6.06379 8.08957C5.26411 9.19729 4.83381 10.5288 4.83398 11.895V26C4.83398 42.302 24.7673 51.3045 25.621 51.6794L26.388 52.0195L27.1853 51.7552C28.0433 51.4692 48.1673 44.5835 48.1673 26V11.895C48.1675 10.5288 47.7372 9.19729 46.9375 8.08957C46.1378 6.98185 45.0095 6.15426 43.7127 5.72436ZM27.4627 30.3095C27.0839 30.6908 26.6331 30.9931 26.1366 31.1988C25.6401 31.4045 25.1076 31.5095 24.5702 31.5077H24.4987C23.9502 31.4993 23.4092 31.3798 22.9084 31.1563C22.4075 30.9329 21.9571 30.6102 21.5845 30.2077L16.5882 25.0077L19.7147 22.0134L24.5767 27.0834L35.8022 15.8579L38.8658 18.9215L27.4627 30.3095Z",
    fill: "#660066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b178ac3bfc122923cf4121ea82b458ee.svg";
export { ForwardRef as ReactComponent };